<template>
  <v-layout>
    <v-flex>
      <v-sheet>
        <v-calendar color="primary" :value="sessionDate">
          <template v-slot:day="{ date }">
            <template v-for="event in eventsMap[date]">
              <v-menu :key="event.sessionId" :v-model="false" full-width offset-x>
                <template v-slot:activator="{ on }">
                  <div v-if="!event.time" v-ripple v-bind:class="getClass(event)" v-on="on">
                    <template>
                      <strong>{{moment(event.startTime).format('h:mma')}} - {{moment(event.endTime).format('h:mma')}}</strong>
                      <br />
                      {{event.status === 'CANCELLED' ? 'CANCELLED - ' + event.type : event.type }}
                      <br>
                      {{event.locationName}}
                    </template>
                  </div>
                </template>
                <v-card min-width="350px">
                  <v-toolbar v-bind:color="event.status === 'CANCELLED' ? 'error' : 'alternate'">
                    <v-toolbar-title v-html="event.type"></v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text primary-title>
                    <strong>Event:</strong>
                    {{event.status === 'CANCELLED' ? 'CANCELLED' : event.description}}
                    <br />
                    <br />
                    <strong>Time:</strong>
                    {{moment(event.startTime).format('h:mma')}} - {{moment(event.endTime).format('h:mma')}}
                    <br />
                    <br />
                    <strong>Location:</strong>
                    {{event.locationName}}
                    <br />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" outline>Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<style lang="stylus" scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.my-event-cancelled {
  background-color: #FF5252;
}

.my-event-game {
  background-color: #4CAF50;
}

.my-event-pickup {
  background-color: #2196F3;
}

.my-event-tournament {
  background-color: #0D7A10;
}

.my-event-summer {
  background-color: #F77D02;
}

</style>

<script>
import moment from "moment";

export default {
  props: ["events"],
  data: () => ({}),
  mounted() {},
  computed: {
    sessionDate() {
       return moment(this.$store.state.date).format("YYYY-MM-DD");
    },
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.events.forEach(e =>
        (map[moment(e.sessionDate).format("YYYY-MM-DD")] =
          map[moment(e.sessionDate).format("YYYY-MM-DD")] || []).push(e)
      );
      return map;
    }
  },
  methods: {
    moment,
    open(event) {
      alert(event.title);
    },
    getClass(event) {
      return {
        'my-event': event.type === 'Training',
        'my-event my-event-game': event.type === 'Game' && event.status !== 'CANCELLED',
        'my-event my-event-pickup': event.type === 'Pickup' && event.status !== 'CANCELLED',
        'my-event my-event-summer': event.type === 'Summer' && event.status !== 'CANCELLED',
        'my-event my-event-tournament': event.type === 'Tournament',
        'my-event my-event-cancelled': event.status === 'CANCELLED',
      }
    }
  }
};
</script>